import { EuiButtonEmpty, EuiCollapsibleNavGroup, EuiFlexItem, EuiText } from '@elastic/eui';
import React, { useCallback, useState } from 'react';
import { useSelector } from 'react-redux';
import { fetchCategoryItemsForAddonLink } from '../catalogue/Api/FetchCatalogueInfo';
import AddonLinkItemList from './AddonLinkItemList';
import AddonLinkSubCategoryItemList from './AddonLinkSubCategoryItemList';

const AddonLinkCategoryItemList = ({
    category,
    handleLinkChange,
    selectedAddon,
    handleVariantLinkChange,
    addonVariantLinkStatus,
}) => {
    const isOutletMenu = useSelector((state) => state.menuReducer.isOutletMenu);
    const languageId = useSelector((state) => state.language.languageId);
    const [listDetails, setListDetails] = useState({
        items: [],
        sub_categories: [],
        isLoading: false,
    });

    const categories = useSelector((state) => state.menuReducer.restaurantCategories);
    const subCategories = categories.filter(
        (sub_category) => sub_category.parent_id && sub_category.parent_id === category.category_id
    );

    const doesSubCategoryExist =
        subCategories.filter((sub_category) => sub_category.parent_id === category.category_id).length > 0;

    const handleCategoryClick = useCallback(
        (selectedCategory, isSubCategory) => {
            let items = [];
            if (!doesSubCategoryExist || isSubCategory) {
                setListDetails((prevState) => ({ ...prevState, isLoading: true }));
                fetchCategoryItemsForAddonLink(selectedCategory.category_id, languageId)
                    .then((response) => {
                        if (response.success) {
                            items.push(...response.items);
                            setListDetails((prevState) => ({ ...prevState, items: items, isLoading: false }));
                        } else {
                            setListDetails((prevState) => ({ ...prevState, isLoading: false }));
                        }
                        setListDetails((prevState) => ({
                            ...prevState,
                            isLoading: false,
                        }));
                    })
                    .catch((err) => {
                        setListDetails((prevState) => ({
                            ...prevState,
                            isLoading: false,
                        }));
                    });
            }
        },
        [doesSubCategoryExist, languageId]
    );

    const itemListRender = useCallback(
        (itemList) => {
            let list = [];
            if (itemList?.length) {
                itemList.forEach((item) => {
                    list.push(
                        <AddonLinkItemList
                            key={item.item_id.toString()}
                            handleLinkChange={handleLinkChange}
                            item={item}
                            itemList={itemList}
                            addonVariantLinkStatus={addonVariantLinkStatus}
                            selectedAddon={selectedAddon}
                            handleVariantLinkChange={handleVariantLinkChange}
                        />
                    );
                });
            }

            return list;
        },
        [handleLinkChange, selectedAddon, handleVariantLinkChange, addonVariantLinkStatus]
    );

    return (
        <>
            {category.parent_id === null ? (
                <EuiCollapsibleNavGroup
                    key={category.category_id.toString()}
                    background='light'
                    title={
                        <EuiText>
                            <h3>
                                {isOutletMenu ? category?.translations?.title[languageId] : category?.internal_name}
                            </h3>
                        </EuiText>
                    }
                    isCollapsible={true}
                    initialIsOpen={false}
                    arrowDisplay={'left'}
                    isLoading={listDetails.isLoading}
                    onToggle={(isOpen) => {
                        if (isOpen && !listDetails.items.length) {
                            handleCategoryClick(category);
                        }
                    }}
                >
                    {listDetails.isLoading && !subCategories?.length ? (
                        <EuiFlexItem grow={false}>
                            <EuiButtonEmpty isLoading={true}>Loading</EuiButtonEmpty>
                        </EuiFlexItem>
                    ) : (
                        <>
                            {subCategories?.length ? (
                                <EuiFlexItem style={{ minWidth: '40vw' }}>
                                    {subCategories.map((subCategory, index) => {
                                        return (
                                            <AddonLinkSubCategoryItemList
                                                category={subCategory}
                                                selectedAddon={selectedAddon}
                                                addonVariantLinkStatus={addonVariantLinkStatus}
                                                handleLinkChange={handleLinkChange}
                                                handleVariantLinkChange={handleVariantLinkChange}
                                                key={subCategory.category_id.toString() + index.toString()}
                                            />
                                        );
                                    })}
                                </EuiFlexItem>
                            ) : null}

                            {itemListRender(listDetails.items)}
                        </>
                    )}
                </EuiCollapsibleNavGroup>
            ) : null}
        </>
    );
};

export default React.memo(AddonLinkCategoryItemList);
